// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-df589b94]{padding:100px 0 20px;background:#f7f8f9;position:relative}.box[data-v-df589b94]:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:386px;background:#386ff2}.box-main[data-v-df589b94]{z-index:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
